import React, { Component } from 'react';
import TitleWithControl from '../../ComponentsPedidos/TitleWithControl';
import ButtonContinue from '../../ComponentsPedidos/ButtonContinue';
import { BillingObservationContainer, BillingObservationContainerContent, BillingObservationContainerContentFieldTitle, BillingObservationContainerContentTitle } from './styles';

class BillingObservation extends Component {

    constructor(props){
        super(props);
        this.state = {
                        data_billing:this.props.data_request,
                        all_billing:this.props.all_request,
                        company_select:this.props.company_select,
                        data_client:this.props.data_client,
                        data_delivery:this.props.data_delivery,
                        
                     }
    }

    componentDidMount(){
        console.log(this.state.data_billing);
        console.log(this.state.all_billing);
        console.log(this.state.company_select);
        console.log(this.state.data_client);
        console.log(this.state.data_delivery);
    }

    render() {
        return (
            <div>
                <BillingObservationContainer>
                    <TitleWithControl width={420} back={this.props.back}>
                        <p><strong>OBSERVAÇÃO</strong> DE DADOS ADICIONAIS NA NOTA FISCAL</p>
                    </TitleWithControl>

                    <BillingObservationContainerContent>
                        <BillingObservationContainerContentTitle>
                            <p>Neste campo é possivel incluir detalhes para dados adicionais da nota fiscal.</p>
                        </BillingObservationContainerContentTitle>
                        <BillingObservationContainerContentFieldTitle>
                            <label>OBSERVAÇÕES AO CLIENTE</label>
                            <textarea></textarea>
                        </BillingObservationContainerContentFieldTitle>
                        
                    </BillingObservationContainerContent>

                    <ButtonContinue onClick={this.props.continue}/>

                </BillingObservationContainer>
            </div>
        );
    }
}


export default BillingObservation;